import { MESSAGE_MANUAL_TOGGLE_FAILED } from './constants.js';

export async function fetchSearchResults(baseUrl, query, options = {}) {
    try {
        const normalizedQuery = String(query ?? '').trim();
        const params = new URLSearchParams();
        params.set('q', normalizedQuery);
        const manualListId = String(options.manualListId ?? '').trim();
        if (manualListId !== '') {
            params.set('manual_list_id', manualListId);
        }

        const offset = Number.isInteger(options.offset) && options.offset > 0 ? options.offset : 0;
        if (offset > 0) {
            params.set('offset', String(offset));
        }

        const requestUrl = `${baseUrl}?${params.toString()}`;
        const response = await fetch(requestUrl, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            return null;
        }

        return await parseJsonSafely(response);
    } catch (error) {
        console.error('Global search request failed', error);
        return null;
    }
}

export async function toggleManualListMembershipRequest({ toggleUrl, csrfToken, payload: requestPayload }) {
    try {
        const response = await fetch(toggleUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            credentials: 'same-origin',
            body: JSON.stringify(requestPayload),
        });

        const responsePayload = await parseJsonSafely(response);
        if (response.ok && isObject(responsePayload) && responsePayload.success === true) {
            return {
                ok: true,
                payload: responsePayload,
                errorMessage: '',
            };
        }

        const errorMessage = isObject(responsePayload) && typeof responsePayload.error === 'string'
            ? responsePayload.error
            : MESSAGE_MANUAL_TOGGLE_FAILED;

        return {
            ok: false,
            payload: responsePayload,
            errorMessage,
        };
    } catch (error) {
        console.error('Manual list membership toggle failed', error);

        return {
            ok: false,
            payload: null,
            errorMessage: MESSAGE_MANUAL_TOGGLE_FAILED,
        };
    }
}

async function parseJsonSafely(response) {
    try {
        return await response.json();
    } catch (error) {
        return null;
    }
}

function isObject(value) {
    return typeof value === 'object' && value !== null;
}
